import React from 'react'
import PropTypes from 'prop-types'
import ImageCarousel from 'reusableComponents/ImageCarousel'
import styled from 'styled-components'

const StyledPhotoPod = styled.div`
  display: flex;
  justify-content: left;
  align-items: left;
  padding-bottom: 24px;
  margin-left: 32px;
`

const PhotoPod = ({ photoPODImages }) => {
  return (
    <StyledPhotoPod>
      <ImageCarousel images={photoPODImages} />
    </StyledPhotoPod>
  )
}

PhotoPod.propTypes = {
  photoPODImages: PropTypes.arrayOf(PropTypes.string),
}

PhotoPod.defaultProps = {
  photoPODImages: [],
}

export default PhotoPod
